/**
 * Log levels
 */
export enum LogLevels {
  DEBUG = 10,
  INFO = 20,
  AUDIT = 30,
  WARN = 40,
  ERROR = 50,
  FATAL = 60,
}

export const isCritical = (logLevel?: LogLevels): boolean =>
  logLevel === LogLevels.ERROR ||
  logLevel === LogLevels.WARN ||
  logLevel === LogLevels.FATAL;
